module.exports = __webpack_public_path__ + "img/certificate_bottom_chinese_text.a5028c9a.svg";